'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.LG}rem;
  padding: ${Spacers.LG}rem;
  width: 100%;
`;

export const DetailHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacers.BASE}rem;
  margin-bottom: ${Spacers.LG}rem;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: ${(props) => props.theme.colors.brand};
  cursor: pointer;
  box-sizing: border-box;
  padding: ${Spacers.XS}rem;

  & > svg {
    width: 1.5rem;
    height: 1.5rem;
    flex: 0 0 auto;
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.backgroundAccent};
    border-radius: ${Spacers.XS}rem;
  }
`;

export const DetailTitle = styled.h1`
  font-size: ${(props) => props.theme.typography.heading1.fontSize};
  font-weight: ${(props) => props.theme.typography.heading1.fontWeight};
  line-height: ${(props) => props.theme.typography.heading1.lineHeight};
`;

export const InfoGrid = styled.div<{ className?: string }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: ${Spacers.XXL}rem;
  padding: ${Spacers.LG}rem;
  padding-top: ${(props) => (props.className === 'teacher info' ? '0' : `${Spacers.LG}rem`)};
  box-sizing: border-box;
`;

export const InfoField = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.SM}rem;
`;

export const InfoLabel = styled.span`
  font-size: ${(props) => props.theme.typography.label.fontSize};
  font-weight: ${(props) => props.theme.typography.label.fontWeight};
  line-height: ${(props) => props.theme.typography.label.lineHeight};
  color: ${(props) => props.theme.colors.typographyBodyLight};
`;

export const InfoValue = styled.span`
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacers.BASE}rem;
`;

export const EditButton = styled.button`
  border: none;
  color: ${(props) => props.theme.colors.brand};
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.colors.actionHover};
  }
`;

export const StatusEditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacers.BASE}rem;
`;

export const InlineButtonWrapper = styled.div`
  display: inline-flex;
  gap: ${Spacers.SM}rem;
`;

export const StatusSelect = styled.select`
  padding: ${Spacers.XS}rem;
  border: 1px solid ${(props) => props.theme.colors.adminBorder};
  border-radius: 0.25rem;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
`;

export const ReviewsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
  padding: ${Spacers.LG}rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props) => props.theme.colors.adminBorder};
`;

export const ReviewsHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
`;

export const ReviewsTitle = styled.h3`
  font-size: ${(props) => props.theme.typography.title.fontSize};
  font-weight: ${(props) => props.theme.typography.title.fontWeight};
  margin: 0 0 ${Spacers.BASE}rem 0;
`;

export const StarSection = styled.span`
  display: flex;
  align-items: center;
  gap: ${Spacers.XS}rem;
`;

export const ReviewItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacers.BASE}rem;
  border: 1px solid ${(props) => props.theme.colors.adminBorder};
  border-radius: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.backgroundScroll};
  }
`;

export const ReviewInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${Spacers.BASE}rem;
`;

export const ReviewerName = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.SM}rem;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};

  span:first-child {
    color: ${(props) => props.theme.colors.backgroundDark};
    font-size: ${(props) => props.theme.typography.body.fontSize};
    font-weight: ${(props) => props.theme.typography.body.fontWeight};
  }

  span:last-child {
    color: ${(props) => props.theme.colors.typographyBodyLight};
    font-size: ${(props) => props.theme.typography.body.fontSize};
    font-weight: ${(props) => props.theme.typography.body.fontWeight};
  }
`;

export const ReviewDate = styled.span`
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
`;
export const ModalOpenRating = styled.div`
  display: flex;
  justify-content: center;
`;

export const CommentSection = styled.div`
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};
  line-height: ${(props) => props.theme.typography.body.lineHeight};
  background-color: ${(props) => props.theme.colors.backgroundScroll};
  padding: ${Spacers.LG}rem;
  border-radius: 0.5rem;
`;

export const AvatarPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const AvatarSection = styled.div`
  flex-shrink: 0;
`;

export const Avatar = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 0.5rem;
  object-fit: cover;
`;

export const DetailsSection = styled.div`
  flex: 1;
`;

export const UserItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacers.BASE}rem;
  border: 1px solid ${(props) => props.theme.colors.adminBorder};
  border-radius: 0.5rem;
  background-color: ${(props) => props.theme.colors.backgroundLight};
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.SM}rem;
`;

export const UserName = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.XS}rem;
  font-size: ${(props) => props.theme.typography.body.fontSize};
  font-weight: ${(props) => props.theme.typography.body.fontWeight};

  span:first-child {
    color: ${(props) => props.theme.colors.backgroundDark};
    font-size: ${(props) => props.theme.typography.body.fontSize};
    font-weight: ${(props) => props.theme.typography.title.fontWeight};
  }

  span:last-child {
    color: ${(props) => props.theme.colors.typographyBodyLight};
    font-size: ${(props) => props.theme.typography.label.fontSize};
    font-weight: ${(props) => props.theme.typography.body.fontWeight};
  }
`;

export const DaysSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.XS}rem;
  margin-top: ${Spacers.SM}rem;

  > div {
    display: flex;
    flex-wrap: wrap;
    gap: ${Spacers.XS}rem;
  }
`;

export const DayBadge = styled.span`
  display: inline-block;
  padding: ${Spacers.XS}rem ${Spacers.SM}rem;
  background-color: ${(props) => props.theme.colors.brand};
  color: ${(props) => props.theme.colors.backgroundLight};
  border-radius: 0.25rem;
  font-size: ${(props) => props.theme.typography.label.fontSize};
  font-weight: ${(props) => props.theme.typography.label.fontWeight};
`;

export const TabsWrapper = styled.div`
  display: flex;
  gap: ${Spacers.SM}rem;
  margin-bottom: ${Spacers.LG}rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.adminBorder};
  padding-bottom: ${Spacers.SM}rem;
`;
